import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { MobileBar } from "./MobileBar";
import { Tracking } from "./Tracking";
import { NewsTicker } from "./NewsTicker";
import { FloatingActions } from "./FloatingActions";
import { IntroSplash } from "./IntroSplash";

export const Layout = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return (
    <div className="flex min-h-screen flex-col">
      <Tracking />
      <Header />
      <NewsTicker />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <MobileBar />
      <FloatingActions />
      <IntroSplash />
    </div>
  );
};
